import styles from "./styles.module.scss";
import Input from "components/Input";
import Button from "components/Button";
import dossierService from "api/dossierService";
import { FC, useState } from "react";
import { Props } from "./typings";
import CloseIcon from "assets/icons/close.svg?react";
import { useTranslation } from "react-i18next";

const DossierCreateVersionModal: FC<Props> = ({ item, toggle, refetch }) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");

  const { mutate: createVersion } = dossierService.useCreateVersion();

  const handleClickSave = () => {
    createVersion(
      {
        Id: item.Id,
        Name: name,
      },
      {
        onSuccess: () => {
          refetch();
          toggle(false);
        },
      }
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {t("documents.createVersion")}
        <CloseIcon onClick={() => toggle(false)} className={styles.closeIcon} />
      </div>
      <div className={styles.content}>
        <Input
          placeholder={t("documents.versionName")}
          label={t("common.name")}
          value={name}
          onChange={(text) => setName(text)}
        />
      </div>
      <div className={styles.footer}>
        <Button
          disabled={!name.length}
          onClick={handleClickSave}
          text={t("common.create")}
        />
      </div>
    </div>
  );
};

export default DossierCreateVersionModal;
